import io from 'socket.io-client';
import apiConfig from '../../config';
import { define } from '../redux-request';
import api from '../../api/api';
import {
  getNotificationCountRequest, NEW_NOTIFICATION, SOCKET_OFFLINE, SOCKET_ONLINE,
} from './rightBar';

const { API_URL } = apiConfig;

export const SOCKET_CHAT_NEW_MESSAGE = 'SOCKET_CHAT_NEW_MESSAGE';
export const SOCKET_CHAT_NEW_MESSAGE_ANOTHER_HEALTH_PLAN = 'SOCKET_CHAT_NEW_MESSAGE_ANOTHER_HEALTH_PLAN';
export const SOCKET_CHAT_NEW_MESSAGE_ANOTHER_PAGE = 'SOCKET_CHAT_NEW_MESSAGE_ANOTHER_PAGE';
export const SOCKET_CHAT_ONLINE = 'SOCKET_CHAT_ONLINE';
export const SOCKET_CHAT_OFFLINE = 'SOCKET_CHAT_OFFLINE';
export const NEW_CHAT_NOTIFICATION = 'NEW_CHAT_NOTIFICATION';
export const SOCKET_CHAT_USER_TYPING = 'SOCKET_CHAT_USER_TYPING';
export const CHAT_TYPING = 'CHAT_TYPING';
export const MESSAGE_SEEN = 'MESSAGE_SEEN';

let chat;

export function healthPlanSocketInit(token) {
  return (dispatch, getState) => {
    if (chat) {
      return;
    }

    // const token = accountHelpers.getToken();
    chat = io.connect(`${API_URL}/health-plan/chat`, {
      path: '/health-plan/socket.io',
      query: {
        token,
      },
      transports: ['websocket', 'polling'],
    });

    chat.on('newMessage', async (data) => {
      const {
        chatMembersList, activeHealthPlan, room, messagesList, markedHealthPlans,
      } = getState().chat;

      if (activeHealthPlan.id && activeHealthPlan.id !== data.healthPlanId
        && !!markedHealthPlans.find((p) => p.plan.id === data.healthPlanId)) {
        dispatch({
          type: SOCKET_CHAT_NEW_MESSAGE_ANOTHER_HEALTH_PLAN,
          payload: { ...data, newMessages: true },
        });
      } else if (activeHealthPlan.id === data.healthPlanId
        && (!chatMembersList.find((c) => c.chatRoom?.id === data.roomId)
        || !messagesList.find((msg) => msg.id === room.messages[0].id))) {
        dispatch(setAnotherPageRoomRequest(data.roomId));

        if (!messagesList.find((msg) => msg.id === room.messages[0].id)) {
          dispatch({
            type: SOCKET_CHAT_NEW_MESSAGE,
            payload: {
              ...data,
              newMessages: true,
            },
          });

          dispatch(getHealthPlanChatMessagesRequest({
            roomId: data.roomId, messageId: data.messageId, mode: 'down', searchMsg: true, excludeMsg: 0,
          }, true));

          api.markHealthPlanChatSeen(room.id);
        }
      } else {
        dispatch({
          type: SOCKET_CHAT_NEW_MESSAGE,
          payload: {
            ...data,
            newMessages: true,
          },
        });

        if (room.id) api.markHealthPlanChatSeen(room.id);
      }
    });

    chat.on('online', (id) => {
      dispatch({
        type: SOCKET_ONLINE,
        payload: id,
      });
    });

    chat.on('offline', (id) => {
      dispatch({
        type: SOCKET_OFFLINE,
        payload: id,
      });
    });

    chat.on('newNotification', (data) => {
      dispatch({
        type: NEW_NOTIFICATION,
        payload: { data },
      });
    });

    let timeout;

    chat.on('typing', (data) => {
      clearTimeout(timeout);

      dispatch({
        type: CHAT_TYPING,
        payload: { data, typing: true },
      });
      timeout = setTimeout(() => {
        dispatch({
          type: CHAT_TYPING,
          payload: { typing: false, data },
        });
      }, 2000);
    });

    chat.on('messageSeen', (data) => {
      dispatch({
        type: MESSAGE_SEEN,
        payload: data,
      });
    });

    chat.on('notificationCount', async () => {
      await dispatch(getNotificationCountRequest());
    });
  };
}

export const CHAT_DESTROY = 'CHAT_DESTROY';

export function socketDestroy() {
  if (chat) {
    chat.destroy();
    chat = null;
  }
  return {
    type: CHAT_DESTROY,
  };
}

export const CHAT_TYPING_USER = 'CHAT_TYPING_USER';

export function sendTyping(roomId, senderId) {
  chat.emit('typing', {
    roomId,
    senderId,
  });

  return {
    type: CHAT_TYPING_USER,
  };
}

export const GET_CHAT_HEALTH_PLAN_LIST = define('GET_CHAT_HEALTH_PLAN_LIST');

export function getChatHealthPlanListRequest(data) {
  return GET_CHAT_HEALTH_PLAN_LIST.request(() => api.getChatHealthPlanList(data));
}

export const GET_CHAT_HEALTH_PLAN_MEMBERS_LIST = define('GET_CHAT_HEALTH_PLAN_MEMBERS_LIST');

export function getChatHealthPlanMembersRequest(data) {
  return GET_CHAT_HEALTH_PLAN_MEMBERS_LIST.request(() => api.getChatHealthPlanMembersList(data));
}

export const GET_CHAT_ASSIGN_TO_LIST = define('GET_CHAT_ASSIGN_TO_LIST');

export function getChatAssignToListRequest(data) {
  return GET_CHAT_ASSIGN_TO_LIST.request(() => api.getChatAssignToList(data));
}

export const GET_CHAT_ASSIGN_TO_LIST_WITH_AGENTS = define('GET_CHAT_ASSIGN_TO_LIST_WITH_AGENTS');

export function getChatAssignToListWithAgentsRequest(data) {
  return GET_CHAT_ASSIGN_TO_LIST_WITH_AGENTS.request(() => api.getChatAssignToList(data));
}

export const ASSIGN_USER_TO_HEALTH_PLAN = define('ASSIGN_USER_TO_HEALTH_PLAN');

export function assignUserToHealthPlanRequest(data) {
  return ASSIGN_USER_TO_HEALTH_PLAN.request(() => api.assignUserToHealthPlan(
    { healthPlanId: data.healthPlanId, userId: data.id },
  )).onRequest(() => data);
}

export const GET_CHAT_ASSIGNED_USER = define('GET_CHAT_ASSIGNED_USER');

export function getChatAssignUserRequest(data) {
  return GET_CHAT_ASSIGNED_USER.request(() => api.getChatAssignedUser(data));
}

export const SET_ROOM_ID = define('SET_ROOM_ID');

export function setRoomIdRequest(data, user) {
  return SET_ROOM_ID.request(() => (data.isPatient
    ? api.getHealthPlanRoom()
    : api.setHealthPlanRoom(data)))
    .onSuccess((p) => {
      p.userId = data.userId;

      return p;
    })
    .onRequest(() => ({ id: data.userId, user }));
}

export const SET_TOTAL_MESSAGES_COUNT = 'SET_TOTAL_MESSAGES_COUNT';

export function setTotalMessagesCount(count) {
  return {
    type: SET_TOTAL_MESSAGES_COUNT,
    payload: { count },
  };
}

export const SET_CHAT_LOADING = 'SET_CHAT_LOADING';

export function setChatLoading(data) {
  return {
    type: SET_CHAT_LOADING,
    payload: { data },
  };
}

export const SET_CHAT_USERS_LOADING = 'SET_CHAT_USERS_LOADING';

export function setChatUsersLoading(data) {
  return {
    type: SET_CHAT_USERS_LOADING,
    payload: { data },
  };
}

export const SET_CHAT_DIRECT_LOADING = 'SET_CHAT_DIRECT_LOADING';

export function setChatDirectLoading(data) {
  return {
    type: SET_CHAT_DIRECT_LOADING,
    payload: { data },
  };
}

export const SET_SELECTED_USER = 'SET_SELECTED_USER';

export function setSelectedUser(data) {
  return {
    type: SET_SELECTED_USER,
    payload: { data },
  };
}

export const GET_HEALTH_PLAN_CHAT_MESSAGES = define('GET_HEALTH_PLAN_CHAT_MESSAGES');

export function getHealthPlanChatMessagesRequest(data, reset = false) {
  return GET_HEALTH_PLAN_CHAT_MESSAGES.request(() => api.getHealthPlanChatMessages(data))
    .onSuccess((p) => {
      p.isDownScroll = data.mode === 'up';
      p.isSearched = data.searchMsg;
      p.reset = reset;
      return p;
    });
}

export const SEND_HEALTH_PLAN_CHAT_MESSAGE = define('SEND_HEALTH_PLAN_CHAT_MESSAGE');

export function sendHealthPlanChatMessageRequest(data, resend, resendId) {
  const id = new Date().getTime();

  return SEND_HEALTH_PLAN_CHAT_MESSAGE.request(() => api.sendHealthPlanChatMessage({
    ...data,
    files: data?.files?.map((f) => f.id) || [],
  }))
    .onRequest(() => ({ ...data, id: resendId || id, resend }))
    .onSuccess((p) => (
      {
        lastMessageId: id, id: p.data.newMessage.id, roomId: data.roomId, files: data?.files?.map((f) => f.url),
      }
    ))
    .onFail((p) => ({ ...p, ...data, id }));
}

export const GET_MARKED_HEALTH_PLANS = define('GET_MARKED_HEALTH_PLANS');

export function getMarkedHealthPlansRequest(data) {
  return GET_MARKED_HEALTH_PLANS.request(() => api.getMarkedHealthPlans(data));
}

export const MARK_HEALTH_PLAN = define('MARK_HEALTH_PLAN');

export function markHealthPlanRequest(id) {
  return MARK_HEALTH_PLAN.request(() => api.markHealthPlan(id))
    .onRequest(() => id);
}

export const MARK_HEALTH_PLAN_ACTIVE = define('MARK_HEALTH_PLAN_ACTIVE');

export function markHealthPlanActiveRequest(id) {
  return MARK_HEALTH_PLAN_ACTIVE.request(() => api.markHealthPlanActive(id));
}

export const MARK_HEALTH_PLAN_CHAT_SEEN = define('MARK_HEALTH_PLAN_CHAT_SEEN');

export function markHealthPlanChatSeenRequest(roomId) {
  return MARK_HEALTH_PLAN_CHAT_SEEN.request(() => api.markHealthPlanChatSeen(roomId))
    .onRequest(() => roomId);
}

export const GET_UNSEEN_COUNT = define('GET_UNSEEN_COUNT');

export function getUnseenCountRequest() {
  return GET_UNSEEN_COUNT.request(() => api.getUnseenCount());
}

export const GET_MESSAGE_LIST_BY_ID = define('GET_MESSAGE_LIST_BY_ID');

export function getMessageListByMessageIdRequest(messageId) {
  return GET_MESSAGE_LIST_BY_ID.request(() => api.getMessageListByMessageId(messageId));
}

export const SET_ANOTHER_PAGE_ROOM = define('SET_ANOTHER_PAGE_ROOM');

export function setAnotherPageRoomRequest(roomId) {
  return SET_ANOTHER_PAGE_ROOM.request(() => api.getRoomData(roomId));
}

export const RESET_CHAT = 'RESET_CHAT';

export function resetChat() {
  return {
    type: RESET_CHAT,
  };
}
